import BaseUrl from "../component/BaseUrl";

export const getAllTherapist = async (search) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.get(`/api/Users/GetTherapists?name=${search}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const saveTherapist = async (body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.post("/api/Users/SaveTherapist", body, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const GetTherapistById = async (id) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.get(`/api/Users/GetTherapistById/${id}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const updateTherapist = async (body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.put("/api/Users/UpdateTherapist", body, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const deleteTherapist = async (id) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.delete(`/api/Users/DeleteTherapist/${id}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}

// therapist and case manager image upload db is same

export const uploadImage = async (body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.post(`/api/Users/UploadProfilepicture`, body, config);
        return response;
    } catch (err) {
        return err.response
    }
}